<template>
  <el-dialog
    :append-to-body="true"
    :visible.sync="dialogDetailVisible"
    class="swiper-collect"
    width="1125px"
    @close="closeDialog"
  >
    <div class="wrap">
      <!-- 左右切换按钮 -->
      <!-- <i class="item-icon el-icon-arrow-left" @click="handlePrev" :style="styleObjectLeft"></i>
      <i class="item-icon el-icon-arrow-right" @click="handleNext" :style="styleObjectRight"></i>-->

      <!-- 未收藏 -->
      <!-- <svg-icon icon-class="collect" class-name="icon-collect"/> -->

      <div class="swiper-box">
        <img src :onerror="defaultImg" alt v-if="!pictureIds" style="width:375px;height:375x">

        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop" style="width:375px;">
          <swiper-slide v-for="(item, index) in pictureIds" :key="index">
            <viewer>
              <img ref="picView" class="pic-view g-pointer" :src="item.attPath" alt>
            </viewer>

            <!-- <span class="g-pointer">
              <svg-icon
                icon-class="collect"
                class-name="icon-collect"
                v-if="detailData.isCollected==='0'"
                @click.native="clickCollect"
              />
              <svg-icon
                v-if="detailData.isCollected==='1'"
                icon-class="collect-active"
                class-name="icon-collect"
                @click.native="cancelCollect"
              />
            </span> -->
            <span class="pic-old m-btn" @click="clickPicView(index)" v-if="showOrig">查看原图</span>
            <!-- <a :href="item.attPath" target="_blank" class="m-btn">查看原图</a> -->
          </swiper-slide>
        </swiper>

        <!-- 轮播 -->
        <div class="swiper-list mt-20">
          <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
            <swiper-slide v-for="(item, index) in pictureIds" :key="index">
              <img :src="item.attPath" alt>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!-- 右侧内容 -->
      <div class="content-box">
        <!-- 面包屑 -->
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <span @click="showBase=true" :class="{inforColor:showBase}" class="msg g-pointer">基本信息</span>
          </el-breadcrumb-item>
          <el-breadcrumb-item>
            <span @click="showBase=false" :class="{inforColor:!showBase}" class="msg g-pointer">更多详情</span>
          </el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 基本信息 -->
        <div class="tab1" v-show="showBase">
          <!-- <h5>{{ collectName }}</h5> -->
          <h5>{{collectName}}</h5>

          <el-row>
            <el-col :span="8">
              <div class="infoContent">
                <h6 class="mb-20 titName">编号类型 :</h6>
                <div class="m-tit ml-10">{{detailData.collectNumberType}}</div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="baseContent">
                <h6 class="mb-20">藏品编号 :</h6>
                <div class="m-tit ml-10">{{detailData.collectCode}}</div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <div class="infoContent">
                <h6 class="mb-20 titName">年代类型 :</h6>
                <div class="m-tit ml-10 mb-10">{{collectYear[0]}}</div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="baseContent">
                <h6 class="mb-20">年代 :</h6>
                <div class="m-tit ml-10 mb-10">{{collectYear[1]}}</div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="baseContent">
                <h6 class="mb-20">具体年代 :</h6>
                <div class="m-tit ml-10 mb-10">{{collectYear[2]}}</div>
              </div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="8">
              <div class="infoContent">
                <h6 class="mb-20 titName">文物类别 :</h6>
                <div class="m-tit ml-10">{{detailData.collectType}}</div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="baseContent">
                <h6 class="mb-20">文物级别 :</h6>
                <div class="m-tit ml-10">{{ detailData.collectLevel}}</div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="baseContent">
                <h6 class="mb-20">文物来源 :</h6>
                <div class="m-tit ml-10">{{detailData.source}}</div>
              </div>
            </el-col>
          </el-row>

          <el-row class="mb-10">
            <el-col :span="8">
              <div class="infoContent">
                <h6 class="mb-20 titName">质地类别 :</h6>
                <div class="m-tit ml-10">{{ collectTexture[0] }}</div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="baseContent">
                <h6 class="mb-20">藏品材质 :</h6>
                <div class="m-tit ml-10">{{collectTexture[1]}}</div>
              </div>
            </el-col>

            <el-col :span="8">
              <div class="baseContent">
                <h6 class="mb-20">质地 :</h6>
                <div class="m-tit ml-10">{{collectTexture[2]}}</div>
              </div>
            </el-col>
          </el-row>

          <el-table :data="tableList" border stripe>
            >
            <el-table-column prop="num" label="传统数量" width="213"></el-table-column>
            <el-table-column prop="numUnit" label="数量单位" width="212"></el-table-column>
            <el-table-column prop="detailNumber" label="实际数量" width="212"></el-table-column>
          </el-table>

          <el-table class="mt-10" :data="tableList" border stripe>
            <el-table-column label="通长" width="159">
              <template slot-scope="scope">
                {{scope.row.collectLength}}
                <span v-if="scope.row.collectLength">cm</span>
              </template>
            </el-table-column>
            <el-table-column label="通宽" width="159">
              <template slot-scope="scope">
                {{scope.row.collectWidth}}
                <span v-if="scope.row.collectWidth">cm</span>
              </template>
            </el-table-column>
            <el-table-column label="通高" width="159">
              <template slot-scope="scope">
                {{scope.row.collectHeight}}
                <span v-if="scope.row.collectHeight">cm</span>
              </template>
            </el-table-column>
            <el-table-column prop="detailSize" label="具体尺寸" width="160"></el-table-column>
          </el-table>

          <el-table class="mt-10" :data="tableList" border stripe>
            <el-table-column prop="qualityRange" label="质量范围" width="213"></el-table-column>
            <el-table-column prop="detailQuality" label="具体质量" width="212"></el-table-column>
            <el-table-column prop="qualityType" label="单位" width="212"></el-table-column>
          </el-table>

          <h4 class="mt-20 mb-20">保存情况</h4>
          <el-row>
            <el-col :span="12" class="mb-20">
              <span class="m-tit">完残状况：{{ detailData.residualInfo }}</span>
            </el-col>
            <el-col :span="12" class="mb-20">
              <span class="m-tit">完残程度：{{ detailData.collectDisablity }}</span>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <div class="infoContent jianjie mb-20">
                <h6 class="mb-20">藏品简介 :</h6>
                <div class="m-tit ml-10">{{detailData.collectSynopsis}}</div>
              </div>
            </el-col>
          </el-row>
        </div>

        <!-- 更多详情 -->
        <div class="tab2" v-show="!showBase">
          <div class="info title">
            <!-- <h5>{{ collectName }}</h5> -->
            <h5>{{collectName}}</h5>
            <el-row>
              <el-col :span="11">
                <div class="infoContent">
                  <h6 class="mb-20">原名:</h6>
                  <div class="m-tit ml-20">{{ otherCollect.sourceName }}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">收藏单位 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.collectUnit}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">库房名称 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.storgeName}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">位置详情 :</h6>
                  <div
                    class="m-tit ml-20"
                    v-if="otherCollect.positionLevelName"
                  >{{otherCollect.positionLevelName}}/{{otherCollect.positionLevelCode}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">入藏年度 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.enterCollectYear}}</div>
                </div>
                <!-- <div class="infoContent">
                  <h6 class="mb-20">审核员 :</h6>
                  <div class="m-tit ml-20">审核员</div>
                </div>-->
                <div class="infoContent">
                  <h6 class="mb-20">著者 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.author}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">三维信息 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.threeDimensionalInfo}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">环拍信息 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.ringShotInfo}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">音频讲解词 :</h6>
                  <!-- <div class="m-tit ml-20">音频讲解词</div> -->
                  <div class="m-tit ml-20" style="width: 260px;" v-if="otherCollect.audioIds">
                    <cmpMyAudio :audioHttp="otherCollect.audioIds" :audioStatus="audioStatus"></cmpMyAudio>
                  </div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">附件 :</h6>
                  <cmpUploadProgress
                    ref="cmpUploadProgress"
                    :fileList="otherCollect.collectAttachments"
                    :showUpload="false"
                  ></cmpUploadProgress>
                </div>
              </el-col>

              <el-col :span="13">
                <div class="infoContent">
                  <h6 class="mb-20">普查编号 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.censusNumber}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">收藏单位编号 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.collectUnitNumber}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">货架 :</h6>
                  <div class="m-tit ml-20">{{ otherCollect.positionName }}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">入藏时间范围 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.enterCollectRange}}</div>
                </div>
                <!-- <div class="infoContent">
                  <h6 class="mb-20">录入员 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.entryPerson}}</div>
                </div>-->
                <div class="infoContent">
                  <h6 class="mb-20">存卷 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.fileKeep}}</div>
                </div>
                <div class="infoContent">
                  <h6 class="mb-20">版本 :</h6>
                  <div class="m-tit ml-20">{{otherCollect.version}}</div>
                </div>
              </el-col>
            </el-row>
            <div>
              <el-tag
                :key="item.type"
                v-for="item in detailData.markId"
                closable
                :disable-transitions="false"
                @close="handleClose(item)"
                ref="tag"
              >标签一</el-tag>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下方内容 -->
    <div class="lifeCycle">
      <h4 class="mb-30 mt-10">生命周期</h4>
      <div class="lifeCycle-content">
        <el-steps :active="1">
          <el-step
            v-for="(item,index) in bsLifeCycleList"
            :description="item.createTime"
            :title="item.cycleType"
            :key="index"
          ></el-step>
        </el-steps>
      </div>
    </div>

    <dialog-choose-favor
      ref="dialogChooseFavor"
      :chooseRowIds="collectNum"
      :pageType="'detail'"
      @refresh="refreshDetail"
    ></dialog-choose-favor>
  </el-dialog>
</template>

<script>
import 'swiper/dist/css/swiper.min.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import cmpMyAudio from '@cmp/my-audio/audio'
import cmpUploadProgress from '@cmp/my-upload/upload-progress'
import dialogChooseFavor from './dialog-choose-favor'
export default {
  components: {
    swiper,
    swiperSlide,
    cmpMyAudio,
    cmpUploadProgress,
    dialogChooseFavor
  },
  props: {
    // 父页面是否需要更新
    needRefresh: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let vm = this
    return {
      defaultImg: this.$store.state.app.defaultImg, // 默认图片
      // isActive: true,
      collectName: '',
      dialogShow: false,
      dialogDetailVisible: false,
      status: false,
      showBase: true, //展示基本信息
      baseColor: true,
      moreColor: false,
      audioStatus: '',
      url:
        'http://ws.stream.qqmusic.qq.com/M500001VfvsJ21xFqb.mp3?guid=ffffffff82def4af4b12b3cd9337d5e7&uin=346897220&vkey=6292F51E1E384E06DCBDC9AB7C49FD713D632D313AC4858BACB8DDD29067D3C601481D36E62053BF8DFEAF74C0A5CCFADD6471160CAF3E6A&fromtag=46', //音频链接
      detailData: '',
      showOrig: true,
      tableList: [],
      dictName: [],
      otherCollect: '',
      bsLifeCycleList: [],
      pictureIds: [],
      afterCollectId: '',
      beforeCollectId: '',
      collectNum: '',
      collectTexture: [], //质地
      collectYear: [], //年代
      swiperOptionTop: {
        spaceBetween: 10,
        on: {
          slideChange() {
            vm.$refs.swiperThumbs.swiper.slideTo(this.activeIndex)
            // vm.detailData = vm.pictureIds[this.activeIndex]
          }
        }
      },

      swiperOptionThumbs: {
        spaceBetween: 10,
        slidesPerView: 4,

        on: {
          click: function() {
            // console.log(vm.pictureIds[this.clickedIndex])
            if (typeof this.clickedIndex === 'undefined') return
            vm.$refs.swiperTop.swiper.slideTo(this.clickedIndex)
            // vm.detailData = vm.pictureIds[this.clickedIndex]
          }
        }
      },

      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        on: {
          click: function() {
            console.log(vm.pictureIds[this.clickedIndex])
            if (this.clickedIndex) return
            // vm.detailData = vm.pictureIds[this.clickedIndex]
          },
          slideChange() {
            // vm.detailData = vm.pictureIds[this.activeIndex]
          }
        }
      },
      swiperSlides: [
        'https://www.swiper.com.cn/demo/img/nature1.jpg',
        'https://www.swiper.com.cn/demo/img/nature2.jpg',
        'https://www.swiper.com.cn/demo/img/nature3.jpg',
        'https://www.swiper.com.cn/demo/img/nature4.jpg',
        'https://www.swiper.com.cn/demo/img/nature5.jpg',
        'https://www.swiper.com.cn/demo/img/nature6.jpg'
      ]
    }
  },
  methods: {
    showColor() {
      this.baseColor = true
      this.moreColor = false
    },

    showMore() {
      this.baseColor = false
      this.moreColor = true
    },

    init() {
      this.dialogShow = true
    },
    clickPicView(index) {
      this.$refs.picView[index].click()
    },
    // 收藏
    clickCollect() {
      this.$refs.dialogChooseFavor.init()
    },
    // 取消收藏
    cancelCollect() {
      this.$refs.dialogChooseFavor.cancelCollect()
    },
    // 收藏后更新页面
    refreshDetail() {
      this.detailData.isCollected =
        this.detailData.isCollected === '0' ? '1' : '0'
    },
    // tag标签删除方法
    handleClose(tag) {
      this.dictName.splice(this.dictName.indexOf(tag), 1)
    },
    // 请求藏品详细数据
    getData() {
      this.$http
        .get('/collection/getCollectionById', {
          id: this.collectNum,
        })
        .then(res => {
          if (res.success) {
            this.detailData = res.result.baseCollectInfo
            this.collectYear =  res.result.baseCollectInfo.collectYear && res.result.baseCollectInfo.collectYear.split(',') || []
            this.collectTexture = res.result.baseCollectInfo.collectTexture && res.result.baseCollectInfo.collectTexture.split(
              ','
            ) || []
            this.tableList.push(this.detailData)
            this.otherCollect = res.result.otherCollectInfo
            this.bsLifeCycleList = res.result.bsLifeCycleList

            // 公开藏品列表取缩略图字段
            if(!this.showOrig) {
              this.pictureIds = res.result.thumbsIds
            } else {
              this.pictureIds = res.result.pictureIds
            }
            this.collectName = res.result.collectName
            this.afterCollectId = res.result.afterCollectId
            this.beforeCollectId = res.result.beforeCollectId
          } else {
            this.$message.error(res.message)
          }
        })
    },
    // 关闭弹框
    closeDialog() {
      // 父页面是否需要更新
      if (this.needRefresh) {
        this.$emit('refresh')
      }
      this.showBase = true
      this.audioStatus = 'stop'
    },
    // 接收组件参数弹框
    showDetail(collectId, type) {
      this.showOrig = type==='publicPage' ? false : true  // 公开藏品列表不能查看原图
      this.dialogDetailVisible = true
      this.tableList = []
      this.collectNum = collectId
      this.getData()
    }
  },
  mounted() {}
}
</script>

<style lang="scss" scoped>
.swiper-collect {
  .wrap {
    position: relative;
    display: flex;
    .item-icon {
      position: absolute;
      width: 30px;
      height: 30px;
      line-height: 30px;
      top: 50%;
      color: #9699a2;
      background-color: #fff;
      border-radius: 100%;
      text-align: center;
      cursor: pointer;
      &.primary {
        color: #fff;
        background-color: $primary;
      }
    }
    .icon-collect {
      position: absolute;
      right: 20px;
      bottom: 20px;
      font-size: 30px;
      z-index: 2;
    }
    .el-icon-arrow-left {
      left: -85px;
    }
    .el-icon-arrow-right {
      right: -85px;
    }
    .swiper-box {
      position: relative;
      // width: 500px;
      .pic-view {
        width: 400px;
        height: 400px;
        object-fit: contain;
        background: #f2f2f2;
      }
      .pic-old {
        display: inline-block;
        position: absolute;
        top: 20px;
        right: 20px;
        padding: 3px 15px;
        background: rgba(0, 0, 0, 0.5);
        border-radius: 20px;
      }
      .swiper-list {
        position: relative;
        width: 375px;

        .swiper-container {
          margin-left: 0;
          width: 100%;
          .swiper-slide {
            position: relative;
            width: 83px !important;
            height: 83px;
            margin-right: 14px !important;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              cursor: pointer;
            }
          }
        }
      }
    }
    .swiper-button-prev {
      left: -50px;
    }
    .swiper-button-next {
      right: -50px;
    }
    .content-box {
      padding-left: 30px;
      width: 640px;
      .infoContent {
        display: flex;
        .m-tit {
          color: #575962;
        }
      }
      .jianjie {
        margin-left: -405px;
      }

      h1 {
        margin-bottom: 20px;
      }
      .el-table--border {
        border: 1px solid #f5f6f8f5;
      }
      h5 {
        font-size: 18px;
      }
    }
  }
  /deep/ .el-table th {
    background-color: #f5f6f8;
  }
  /deep/ .el-table th,
  /deep/ .el-table td {
    padding: 8px 0;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #fff;
  }
}
.el-breadcrumb {
  float: right;
  line-height: 20px;
}
/deep/.el-table__row {
  height: 35px;
}
/deep/.el-table th {
  padding: 8px 0;
}
/deep/.el-table .cell {
  color: #9699a2 !important;
}
/deep/.lifeCycle {
  width: 100%;
  overflow-x: auto;
  .lifeCycle-content {
    margin-top: 20px;
    // width: 2000px;
    h4 {
      margin: 20px;
    }
    .el-step {
      margin-bottom: 25px;
      .el-step__icon {
        width: 6px;
        height: 6px;
        border: 1px solid #0590ff;
        font-size: 0;
        top: -3px;
      }
      .el-step__line {
        background-color: #0590ff;
        height: 1px;
      }
      .el-step__title {
        font-size: 14px;
        color: #575962;
      }
      .el-step__description {
        font-size: 14px;
        color: #9699a2;
      }
    }
  }
}
h3 {
  text-align: right;
}
.titName {
  margin-left: 28px;
}
.baseContent {
  display: flex;
  margin-left: 20px;
  .m-tit {
    color: #575962;
  }
}
.msg {
  font-size: 14px;
  color: #9699a2;
  font-weight: 600;
}
.inforColor {
  color: #0590ff;
}
/deep/.el-table__empty-block {
  padding-top: 0;
  padding-bottom: 0;
  min-height: 50px;
  &:before {
    background-image: none;
    height: auto;
  }
}
.title {
  /deep/h6 {
    min-width: 91px;
  }
}
/deep/.cmp-upload-progress {
  display: flex;
  white-space: nowrap;
  .view-file-list li {
    line-height: 0%;
    margin-left: 20px;
    margin-bottom: 8px;
  }
}
/deep/ .el-dialog__body {
  max-height: 800px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>


